"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DapiServer__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_accessControlRegistry",
                type: "address",
            },
            {
                internalType: "string",
                name: "_adminRoleDescription",
                type: "string",
            },
            {
                internalType: "address",
                name: "_manager",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "SetDapiName",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconSetWithBeacons",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconWithSignedData",
        type: "event",
    },
    {
        inputs: [],
        name: "DAPI_NAME_SETTER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accessControlRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRoleDescription",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "containsBytecode",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "dapiNameHashToDataFeedId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dapiNameSetterRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
        ],
        name: "dapiNameToDataFeedId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockBasefee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "manager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "setDapiName",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "beaconIds",
                type: "bytes32[]",
            },
        ],
        name: "updateBeaconSetWithBeacons",
        outputs: [
            {
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x6101206040523480156200001257600080fd5b506040516200203f3803806200203f83398101604081905262000035916200032e565b82828282826001600160a01b038216620000895760405162461bcd60e51b815260206004820152601060248201526f4143522061646472657373207a65726f60801b60448201526064015b60405180910390fd5b6000815111620000dc5760405162461bcd60e51b815260206004820152601c60248201527f41646d696e20726f6c65206465736372697074696f6e20656d70747900000000604482015260640162000080565b6001600160a01b0382166080526000620000f782826200049d565b50806040516020016200010b919062000569565b60408051601f19818403018152919052805160209091012060a05250506001600160a01b038116620001805760405162461bcd60e51b815260206004820152601460248201527f4d616e616765722061646472657373207a65726f000000000000000000000000604482015260640162000080565b6001600160a01b03811660c0526200019881620001ec565b60e052505060c051620001de9150620001b190620001ec565b60408051808201909152601081526f3220a824903730b6b29039b2ba3a32b960811b602082015262000266565b610100525062000587915050565b60006200026062000231836040516001600160601b0319606083901b166020820152600090603401604051602081830303815290604052805190602001209050919050565b60a051604080516020808201949094528082019290925280518083038201815260609092019052805191012090565b92915050565b6000620002a2838360405160200162000280919062000569565b60405160208183030381529060405280519060200120620002a960201b60201c565b9392505050565b604080516020808201949094528082019290925280518083038201815260609092019052805191012090565b80516001600160a01b0381168114620002ed57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b83811015620003255781810151838201526020016200030b565b50506000910152565b6000806000606084860312156200034457600080fd5b6200034f84620002d5565b60208501519093506001600160401b03808211156200036d57600080fd5b818601915086601f8301126200038257600080fd5b815181811115620003975762000397620002f2565b604051601f8201601f19908116603f01168101908382118183101715620003c257620003c2620002f2565b81604052828152896020848701011115620003dc57600080fd5b620003ef83602083016020880162000308565b80965050505050506200040560408501620002d5565b90509250925092565b600181811c908216806200042357607f821691505b6020821081036200044457634e487b7160e01b600052602260045260246000fd5b50919050565b601f8211156200049857600081815260208120601f850160051c81016020861015620004735750805b601f850160051c820191505b8181101562000494578281556001016200047f565b5050505b505050565b81516001600160401b03811115620004b957620004b9620002f2565b620004d181620004ca84546200040e565b846200044a565b602080601f831160018114620005095760008415620004f05750858301515b600019600386901b1c1916600185901b17855562000494565b600085815260208120601f198616915b828110156200053a5788860151825594840194600190910190840162000519565b5085821015620005595787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b600082516200057d81846020870162000308565b9190910192915050565b60805160a05160c05160e05161010051611a61620005de60003960008181610286015261076f0152600061013e01526000818161021701526107200152600050506000818161018b015261079b0152611a616000f3fe608060405234801561001057600080fd5b50600436106101345760003560e01c80634dcc19fe116100b25780638fca9ab911610081578063ac9650d811610066578063ac9650d8146102d6578063f8b2cb4f146102f6578063fce90be81461031157600080fd5b80638fca9ab9146102ae57806391eed085146102c157600080fd5b80634dcc19fe1461024e5780635989eaeb146102545780637512449b14610281578063796b89b9146102a857600080fd5b806342cbb15c11610109578063472c22f1116100ee578063472c22f1146101f2578063481c6a75146102125780634c8f1d8d1461023957600080fd5b806342cbb15c146101cb578063437b9116146101d157600080fd5b80629f2f3c14610139578062aae33f146101735780631ce9ae07146101865780633408e470146101c5575b600080fd5b6101607f000000000000000000000000000000000000000000000000000000000000000081565b6040519081526020015b60405180910390f35b610160610181366004611615565b61034d565b6101ad7f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b03909116815260200161016a565b46610160565b43610160565b6101e46101df3660046116d3565b61048f565b60405161016a9291906117e6565b61016061020036600461183f565b60026020526000908152604090205481565b6101ad7f000000000000000000000000000000000000000000000000000000000000000081565b6102416105f5565b60405161016a9190611858565b48610160565b61027161026236600461186b565b6001600160a01b03163b151590565b604051901515815260200161016a565b6101607f000000000000000000000000000000000000000000000000000000000000000081565b42610160565b6101606102bc36600461183f565b610683565b6102d46102cf366004611894565b6106c8565b005b6102e96102e43660046116d3565b6108d4565b60405161016a91906118b6565b61016061030436600461186b565b6001600160a01b03163190565b6102416040518060400160405280601081526020017f64415049206e616d65207365747465720000000000000000000000000000000081525081565b600080600061035b84610a55565b9150915061036884610bf7565b600081815260016020526040902080549194509063ffffffff808416600160e01b90920416036103ee578054601b84810b91900b036103ee5760405162461bcd60e51b815260206004820152601a60248201527f446f6573206e6f742075706461746520426561636f6e2073657400000000000060448201526064015b60405180910390fd5b604080518082018252601b85900b80825263ffffffff858116602080850182815260008b81526001835287902095519051909316600160e01b027bffffffffffffffffffffffffffffffffffffffffffffffffffffffff90931692909217909355835191825281019190915285917fb7712be6248d021e8c56ac9613c09491354a4d0f4ad0b7db1a664b35be4b2349910160405180910390a2505050919050565b606080828067ffffffffffffffff8111156104ac576104ac6115ff565b6040519080825280602002602001820160405280156104d5578160200160208202803683370190505b5092508067ffffffffffffffff8111156104f1576104f16115ff565b60405190808252806020026020018201604052801561052457816020015b606081526020019060019003908161050f5790505b50915060005b818110156105ec5730868683818110610545576105456118c9565b905060200281019061055791906118df565b60405161056592919061192d565b600060405180830381855af49150503d80600081146105a0576040519150601f19603f3d011682016040523d82523d6000602084013e6105a5565b606091505b508583815181106105b8576105b86118c9565b602002602001018584815181106105d1576105d16118c9565b6020908102919091010191909152901515905260010161052a565b50509250929050565b600080546106029061193d565b80601f016020809104026020016040519081016040528092919081815260200182805461062e9061193d565b801561067b5780601f106106505761010080835404028352916020019161067b565b820191906000526020600020905b81548152906001019060200180831161065e57829003601f168201915b505050505081565b6000600260008360405160200161069c91815260200190565b604051602081830303815290604052805190602001208152602001908152602001600020549050919050565b816107155760405162461bcd60e51b815260206004820152600e60248201527f64415049206e616d65207a65726f00000000000000000000000000000000000060448201526064016103e5565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016148061080e57506040517f91d148540000000000000000000000000000000000000000000000000000000081527f000000000000000000000000000000000000000000000000000000000000000060048201523360248201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906391d1485490604401602060405180830381865afa1580156107ea573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061080e9190611971565b61085a5760405162461bcd60e51b815260206004820152601b60248201527f53656e6465722063616e6e6f74207365742064415049206e616d65000000000060448201526064016103e5565b80600260008460405160200161087291815260200190565b60408051601f1981840301815291815281516020928301208352828201939093529082016000209290925551338152839183917ff3a9aac9b6ac0f842cb5d9b3491cd5fc1b6a6778d97fd9529f587339865294f5910160405180910390a35050565b6060818067ffffffffffffffff8111156108f0576108f06115ff565b60405190808252806020026020018201604052801561092357816020015b606081526020019060019003908161090e5790505b50915060005b81811015610a4d57600030868684818110610946576109466118c9565b905060200281019061095891906118df565b60405161096692919061192d565b600060405180830381855af49150503d80600081146109a1576040519150601f19603f3d011682016040523d82523d6000602084013e6109a6565b606091505b508584815181106109b9576109b96118c9565b6020908102919091010152905080610a445760008483815181106109df576109df6118c9565b602002602001015190506000815111156109fc5780518082602001fd5b60405162461bcd60e51b815260206004820152601b60248201527f4d756c746963616c6c3a204e6f2072657665727420737472696e67000000000060448201526064016103e5565b50600101610929565b505092915050565b8051600090819060018111610aac5760405162461bcd60e51b815260206004820152601f60248201527f537065636966696564206c657373207468616e2074776f20426561636f6e730060448201526064016103e5565b60008167ffffffffffffffff811115610ac757610ac76115ff565b604051908082528060200260200182016040528015610af0578160200160208202803683370190505b50905060008267ffffffffffffffff811115610b0e57610b0e6115ff565b604051908082528060200260200182016040528015610b37578160200160208202803683370190505b50905060005b83811015610bd857600060016000898481518110610b5d57610b5d6118c9565b602090810291909101810151825281019190915260400160002080548551919250601b0b90859084908110610b9457610b946118c9565b602090810291909101015280548351600160e01b90910463ffffffff1690849084908110610bc457610bc46118c9565b602090810291909101015250600101610b3d565b50610be282610c27565b9450610bed81610c27565b9350505050915091565b600081604051602001610c0a9190611993565b604051602081830303815290604052805190602001209050919050565b805160009060098111610d0057610c3d83610d80565b610c486002826119ed565b600103610c7b5782610c5b600283611a01565b81518110610c6b57610c6b6118c9565b6020026020010151915050919050565b80600003610c8b57610c8b611a15565b610cf9836001600284040381518110610ca657610ca66118c9565b60200260200101518460028481610cbf57610cbf6119d7565b0481518110610cd057610cd06118c9565b6020026020010151600182811d82821d01838316919091160160ff81901c838318160192915050565b9392505050565b610d0b6002826119ed565b600103610d275782610c5b81610d22600285611a01565b611292565b600080610d3a85600160028604036112bf565b8092508193505050610d71858381518110610d5757610d576118c9565b6020026020010151868381518110610cd057610cd06118c9565b95945050505050565b50919050565b80516009811115610dd35760405162461bcd60e51b815260206004820152601660248201527f417272617920746f6f206c6f6e6720746f20736f72740000000000000000000060448201526064016103e5565b6006811015610ede576004811015610e2d5780600303610e1857610dfa82600060016112f4565b610e0782600160026112f4565b610e1482600060016112f4565b5050565b80600203610e1457610e1482600060016112f4565b80600503610eaa57610e4282600160026112f4565b610e4f82600360046112f4565b610e5c82600160036112f4565b610e6982600060026112f4565b610e7682600260046112f4565b610e8382600060036112f4565b610e9082600060016112f4565b610e9d82600260036112f4565b610e1482600160026112f4565b610eb782600060016112f4565b610ec482600260036112f4565b610ed182600160036112f4565b610e9d82600060026112f4565b600881101561105b5780600703610fbf57610efc82600160026112f4565b610f0982600360046112f4565b610f1682600560066112f4565b610f2382600060026112f4565b610f3082600460066112f4565b610f3d82600360056112f4565b610f4a82600260066112f4565b610f5782600160056112f4565b610f6482600060046112f4565b610f7182600260056112f4565b610f7e82600060036112f4565b610f8b82600260046112f4565b610f9882600160036112f4565b610fa582600060016112f4565b610fb282600260036112f4565b610e1482600460056112f4565b610fcc82600060016112f4565b610fd982600260036112f4565b610fe682600460056112f4565b610ff382600160036112f4565b61100082600360056112f4565b61100d82600160036112f4565b61101a82600260046112f4565b61102782600060026112f4565b61103482600260046112f4565b61104182600360046112f4565b61104e82600160026112f4565b610e1482600260036112f4565b8060090361118e5761107082600160086112f4565b61107d82600260076112f4565b61108a82600360066112f4565b61109782600460056112f4565b6110a482600160046112f4565b6110b182600560086112f4565b6110be82600060026112f4565b6110cb82600660076112f4565b6110d882600260066112f4565b6110e582600760086112f4565b6110f282600060036112f4565b6110ff82600460056112f4565b61110c82600060016112f4565b61111982600360056112f4565b61112682600660076112f4565b61113382600260046112f4565b61114082600160036112f4565b61114d82600560076112f4565b61115a82600460066112f4565b61116782600160026112f4565b61117482600360046112f4565b61118182600560066112f4565b610fa582600760086112f4565b61119b82600060076112f4565b6111a882600160066112f4565b6111b582600260056112f4565b6111c282600360046112f4565b6111cf82600060036112f4565b6111dc82600460076112f4565b6111e982600160026112f4565b6111f682600560066112f4565b61120382600060016112f4565b61121082600260036112f4565b61121d82600460056112f4565b61122a82600660076112f4565b61123782600360056112f4565b61124482600260046112f4565b61125182600160026112f4565b61125e82600360046112f4565b61126b82600560066112f4565b61127882600260036112f4565b61128582600460056112f4565b610e1482600360046112f4565b8151600090806112a4576112a4611a15565b6112b6846000600184038660006113a2565b50949350505050565b81516000908190600181116112d6576112d6611a15565b6112e8856000600184038760016113a2565b90969095509350505050565b828181518110611306576113066118c9565b6020026020010151838381518110611320576113206118c9565b6020026020010151131561139d57828181518110611340576113406118c9565b602002602001015183838151811061135a5761135a6118c9565b6020026020010151848481518110611374576113746118c9565b6020026020010185848151811061138d5761138d6118c9565b6020908102919091010191909152525b505050565b6000808486036113b75750829050600061146e565b60006113c4888888611478565b9050808510156113e7576113df8888600184038860006113a2565b509250611404565b80851115611400576113df8882600101888860006113a2565b8092505b831561146c57875160018401925060028401905b8082101561146957898481518110611432576114326118c9565b60200260200101518a838151811061144c5761144c6118c9565b6020026020010151121561145e578193505b600190910190611418565b50505b505b9550959350505050565b6000818303611488575081610cf9565b600084848151811061149c5761149c6118c9565b6020026020010151905060008490508360010192505b8551600190910190811080156114e05750818682815181106114d6576114d66118c9565b6020026020010151125b6114b2575b82806001900393505081868481518110611501576115016118c9565b6020026020010151136114e55782811061158c57858381518110611527576115276118c9565b6020026020010151868681518110611541576115416118c9565b602002602001015187878151811061155b5761155b6118c9565b60200260200101888681518110611574576115746118c9565b60200260200101828152508281525050505050610cf9565b85838151811061159e5761159e6118c9565b60200260200101518682815181106115b8576115b86118c9565b60200260200101518783815181106115d2576115d26118c9565b602002602001018886815181106115eb576115eb6118c9565b6020908102919091010191909152526114b2565b634e487b7160e01b600052604160045260246000fd5b6000602080838503121561162857600080fd5b823567ffffffffffffffff8082111561164057600080fd5b818501915085601f83011261165457600080fd5b813581811115611666576116666115ff565b8060051b604051601f19603f8301168101818110858211171561168b5761168b6115ff565b6040529182528482019250838101850191888311156116a957600080fd5b938501935b828510156116c7578435845293850193928501926116ae565b98975050505050505050565b600080602083850312156116e657600080fd5b823567ffffffffffffffff808211156116fe57600080fd5b818501915085601f83011261171257600080fd5b81358181111561172157600080fd5b8660208260051b850101111561173657600080fd5b60209290920196919550909350505050565b6000815180845260005b8181101561176e57602081850181015186830182015201611752565b506000602082860101526020601f19601f83011685010191505092915050565b600082825180855260208086019550808260051b84010181860160005b848110156117d957601f198684030189526117c7838351611748565b988401989250908301906001016117ab565b5090979650505050505050565b604080825283519082018190526000906020906060840190828701845b82811015611821578151151584529284019290840190600101611803565b50505083810382850152611835818661178e565b9695505050505050565b60006020828403121561185157600080fd5b5035919050565b602081526000610cf96020830184611748565b60006020828403121561187d57600080fd5b81356001600160a01b0381168114610cf957600080fd5b600080604083850312156118a757600080fd5b50508035926020909101359150565b602081526000610cf9602083018461178e565b634e487b7160e01b600052603260045260246000fd5b6000808335601e198436030181126118f657600080fd5b83018035915067ffffffffffffffff82111561191157600080fd5b60200191503681900382131561192657600080fd5b9250929050565b8183823760009101908152919050565b600181811c9082168061195157607f821691505b602082108103610d7a57634e487b7160e01b600052602260045260246000fd5b60006020828403121561198357600080fd5b81518015158114610cf957600080fd5b6020808252825182820181905260009190848201906040850190845b818110156119cb578351835292840192918401916001016119af565b50909695505050505050565b634e487b7160e01b600052601260045260246000fd5b6000826119fc576119fc6119d7565b500690565b600082611a1057611a106119d7565b500490565b634e487b7160e01b600052600160045260246000fdfea2646970667358221220bb666fc434ed5ddb19ceaaf6b76918fdafb1fac537ec5f1490c95ae62ac1470f64736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class DapiServer__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_accessControlRegistry, _adminRoleDescription, _manager, overrides) {
        return super.getDeployTransaction(_accessControlRegistry, _adminRoleDescription, _manager, overrides || {});
    }
    deploy(_accessControlRegistry, _adminRoleDescription, _manager, overrides) {
        return super.deploy(_accessControlRegistry, _adminRoleDescription, _manager, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.DapiServer__factory = DapiServer__factory;
//# sourceMappingURL=DapiServer__factory.js.map